/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class ErrorIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="currentcolor"
      {...this.props}
    >
      <g id="error">
        <path
          d="M12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 Z M12,5 C11.4477153,5 11,5.44771525 11,6 L11,14 C11,14.5522847 11.4477153,15 12,15 C12.5522847,15 13,14.5522847 13,14 L13,6 C13,5.44771525 12.5522847,5 12,5 Z M12,18 C12.5522847,18 13,17.5522847 13,17 C13,16.4477153 12.5522847,16 12,16 C11.4477153,16 11,16.4477153 11,17 C11,17.5522847 11.4477153,18 12,18 Z"
          id="Oval"
        />
      </g>
    </svg>;
  }
}

const Icon = pure(ErrorIcon);
Icon.displayName = 'ErrorIcon';
export default Icon;
